// extracted by mini-css-extract-plugin
export default {"container":"DriverDashboard_container__6Ph0V"};